import { z } from 'zod';

export const forgotPasswordSchema = z
  .object({
    newPassword: z.string().min(8, 'validation.passwordLength'),
    confirmPassword: z.string().min(1, 'validation.confirmPassword'),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'validation.passwordsMismatch',
    path: ['confirmPassword'],
  });

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;
